import React from "react"
import { MenuItem, MenuItemProps } from "../MenuItem"

export interface MenuCategoryProps {
  name: string,
  anchorName: string,
  items: any[],
  scrollOffset: Number
}

class MenuCategoryInner extends React.Component<MenuCategoryProps> {
  renderItem(item: MenuItemProps, index: number) {
    return (
      <MenuItem {...item} key={index} />
    )
  }

  render() {
    const {
      name, items, anchorName, scrollOffset,
    } = this.props
    const anchorClasses = `absolute -top-${scrollOffset}`
    return (
      <section className="mb-16 relative">
        <div id={anchorName} className={anchorClasses} />
        <h1 className="text-3xl pb-4">{name}</h1>
        <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {items.map(this.renderItem)}
        </div>
      </section>
    )
  }
}

export function MenuCategory(props: MenuCategoryProps) {
  return <MenuCategoryInner {...props} />
}
